
//TODO: Criar uma conta de admin, a temporaria é email:"teste@teste.com" pass:"teste123"

<template>
  <v-app id="app">
    <v-card flat>
      <v-toolbar color="primary" dark flat>
        <v-btn v-if="user" icon @click.stop="drawer = !drawer">
          <v-icon>menu</v-icon>
        </v-btn>
        <v-toolbar-title class="headline">

          <!-- //TODO: Logo do resultamDocs -->
          <a href="https://docs.resultam.com"><span class="font-weight-bold resultam"><i>resultam</i></span></a>
          <span class="font-weight-light"><sub style="color: lightblue;">docs</sub></span>

        </v-toolbar-title>
        <v-spacer/>

        <template v-if="user">
          <v-avatar>
            <v-icon>account_circle</v-icon>
          </v-avatar>
          <v-btn color="secondary" icon @click="logout()">
            <v-icon>exit_to_app</v-icon>
          </v-btn>
          
        </template>
        
      </v-toolbar>
      <v-card class="card--flex-toolbar">
        <v-content>
          <router-view/>
        </v-content>
      </v-card>
    </v-card>

    <v-navigation-drawer class="menu" v-if="user" v-model="drawer" absolute temporary floating width="220" dark>
      <v-list class="pt-0 my-3" dense two-line>
        <v-list-tile v-for="item in items" :key="item.title" :to="item.route">
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            <v-list-tile-sub-title>{{item.subtitle}}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-footer class="pa-3" fixed dark app>
      <v-spacer/>
      <div> &copy;{{ new Date().getFullYear() }} Resultam</div>
    </v-footer>
  </v-app>
</template>


<script>
//* Importar autenticação, banco de dados do firebase.
import { auth, db } from './firebase'

export default {
  name: 'App',
  beforeCreate() {
    //* Verificação de login e logout
    auth.onAuthStateChanged((user) => {
			if (user) {
				// Set logged user data
				this.user = user
			}
		})
  },
  data () {
    return {
      //var1: foo

      //user null
      user: null,

      //* Variáveis para o menu (navigation drawer)
      menu: false,
      drawer: null,
      items: [
        { title: 'Editor', subtitle: 'Aicionar conteúdo', icon: 'description', route: 'editor' },
        { title: 'Painel Admin', subtitle: 'Administração de Sites', icon: 'dashboard', route: 'admin' },
      ]

    }
  },
  methods: {
    logout() {
			auth.signOut().then(function() {
        //* Define o user como null e recarrega a página (para não se manter na aba errada)
				this.user = null
        this.$router.go({ path: this.$router.path })
			}.bind(this)).catch(function(err) {
				// console.log(err)
			})
		},
  }
}
</script>

<style lang="sass">
  // *Style da Resultam

  @import url('https://fonts.googleapis.com/css?family=Lato');
  #app 
    font-family: 'Lato', sans-serif
  .lato
    font-family: 'Lato', sans-serif

  ::selection 
    background-color: rgba(255, 0, 0, 0.3)
  

  .resultam 
    color: #FFFFFF
    font-family: 'Lato', sans-serif
    letter-spacing: -1px
  
  .menu
    .v-list__tile__content
      color: #FFFFFF
    .v-icon
      color: #FFFFFF !important

  //* Alterações de Style do Vuetify

  // As bordas estavam com um pequeno aumento.
  .v-card>:first-child:not(.v-btn):not(.v-chip) 
    border-top-left-radius: 0px
    border-top-right-radius: 0px

  .v-list__tile--active 
    background-color: rgba(255, 255, 255, 0.2)
  

</style>
